module.exports = __webpack_public_path__ + "img/SubirDocumentoIcon.ee5df2b2.svg";